import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["locale"];
import * as React from 'react';
import { compose } from 'redux';
import { withTranslator } from '@gandi/translate';
import { withAssetPath } from 'gandi.react-asset-path';
var staticComponent = function staticComponent(WrappedComponent) {
  function Static(_ref) {
    var _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en' : _ref$locale,
      extraProps = _objectWithoutProperties(_ref, _excluded);
    return (
      /*#__PURE__*/
      // $FlowFixMe[cannot-spread-inexact]
      React.createElement(WrappedComponent, _extends({
        locale: locale
      }, extraProps))
    );
  }
  return compose(withAssetPath, withTranslator({
    propsNamespace: 'translator'
  }))(Static);
};
export { staticComponent };